import React from "react";
import { useContext, useEffect, useState } from "react";
import Contexto from "../context/Contexto";
import "../assets/css/DesignSeason.css";
import DS10 from "../assets/statics/DS/ds10.jpg";
import DS08 from "../assets/statics/DS/ds8.jpg";
import letra1 from "../assets/statics/DS/letra1.png";
import letra2 from "../assets/statics/DS/letra2.png";
import letra3 from "../assets/statics/DS/letra3.png";
import letra4 from "../assets/statics/DS/letra4.png";
import letra5 from "../assets/statics/DS/letra5.png";
import letra6 from "../assets/statics/DS/letra6.png";
import letra7 from "../assets/statics/DS/letra7.png";
import TAC from "../assets/statics/DS/tac.png";
import CR from "../assets/statics/DS/cr.png";

function DesignSeason() {
  const {
    loguearUsuario,
    mensajes,
    mandarMensajes,
    Griseado,
    usuario,
    cliente,
    seteos,
    agregarCarrito,
    productos,
    cambiaPrecio,
  } = useContext(Contexto);
  const [precioFinal, setPrecioFinal] = useState(22000);
  const [clienteu, setClienteu] = useState(cliente);
  const [cursosQueTienen, setCursosQueTienen] = useState(cliente);
  const [precioLeyenda, setPrecioLeyeneda] = useState("de $14.500 a $22.000");

  let tieneEsteCurso = (curso) => {
    if (seteos) {
      let figma = seteos.BD_TAC.figma;
      let fundamentos = seteos.BD_TAC.fundamentos;
      for (var i in fundamentos) {
        if (fundamentos[i] == usuario.email) return true;
      }
    }
  };

  let tieneFundamentos = () => {
    if (seteos) {
      let fundamentos = seteos.BD_TAC.fundamentos;
      for (var i in fundamentos) {
        if (fundamentos[i] == usuario.email) return true;
      }
    }
  };

  let tieneFigma = () => {
    if (seteos) {
      let figma = seteos.BD_TAC.figma;
      for (var i in figma) {
        if (figma[i] == usuario.email) return true;
      }
    }
  };
  let handleComprar = () => {
    if (cliente == null) {
      loguearUsuario();
    } else {
      checkTAC();
    }
  };
  useEffect(() => {
    console.log("setClienteu");
    setClienteu(cliente);
  }, [cliente]);

  const checkTAC = () => {
    console.log("checkTAC");
    if (seteos) {
      let clien = clienteu;
      tieneEsteCurso("fundamentos");
      if (tieneFigma()) {
        clien.figma = true;
      } else {
        clien.figma = false;
      }
      if (tieneFundamentos()) {
        clien.fundamentos = true;
      } else {
        clien.fundamentos = false;
      }

      setClienteu(clien);
      ajustoPrecio();
    }
  };
  const ajustoPrecio = () => {
    let precioAjuste = 0;

    let txt = `Por tener: `;
    if (clienteu.ux) {
      precioAjuste = precioAjuste + 3000;
      txt = txt + " UX,";
    }
    if (clienteu.figma) {
      precioAjuste = precioAjuste + 3000;
      txt = txt + " Figma,";
    }
    if (clienteu.fundamentos) {
      precioAjuste = precioAjuste + 3000;
      txt = txt + " Fundamentos,";
    }
    txt = txt + " te descontamos $" + precioAjuste;
    setPrecioFinal(30000 - precioAjuste);
    setPrecioLeyeneda(`$${30000 - precioAjuste}`);

    setCursosQueTienen(txt);
    cambiaPrecio("/designseason3", 30000 - precioAjuste);
  };
  const descarguita = () => {
    window
      .open(
        "https://codearock.com/descargas/DesignSeason_Programa.pdf",
        "_blank"
      )
      .focus();
  };
  return (
    <>
      <section className="ds">
        <div className="ds_pic off" id="DS01"></div>
        <div className="ds_txt naranjaDSB alineadoLeft">
          <h1>Aprendé a diseñar experiencias e interfaces profesionales</h1>
          <br />
          <div className="infoComprA">
            <button
              className="btn-azul"
              onClick={() => {
                handleComprar();
              }}
            >
              comprar ticket
            </button>{" "}
            {precioFinal == 22000 ? (
              <p className="ds-precio">de $21.000 a $30.000</p>
            ) : (
              <>
                <del className="ds-del">de $19.000 a $30.000</del>
                <p className="ds-precio-viejos">{cursosQueTienen}</p>
                <p className="ds-precio">{precioLeyenda}</p>
              </>
            )}
            <p className="ds-cuotas">3 y 6 cuotas sin interés</p>
          </div>
          <img src={letra1} alt="" className="letra-decorate" />
        </div>
      </section>
      <section className="ds">
        <div className="ds_txt celesteDSB" id="ds1">
          <p className="txt-cuerpo">
            Sumate a Jony y Ceci en este programa intensivo de 9 semanas y
            convertite en uno de los perfiles más buscados del mundo IT. Vas a
            aprender todo lo necesario para ser parte del mundo del diseño de
            interfaces: UX, UI, Fundamentos de diseño y Figma.
          </p>

          <br />
          <div className="infoComprA">
            <button
              className="btn-naranja"
              onClick={() => {
                handleComprar();
              }}
            >
              comprar ticket
            </button>
            {precioFinal == 22000 ? (
              <p className="ds-precio">de $21.000 a $30.000</p>
            ) : (
              <>
                <del className="ds-del">de $21.000 a $30.000</del>
                <p className="ds-precio-viejos">{cursosQueTienen}</p>
                <p className="ds-precio">{precioLeyenda}</p>
              </>
            )}
            <p className="ds-cuotas">3 y 6 cuotas sin interés</p>
            <img src={letra2} alt="" className="letra-decorateLeft" />
          </div>
        </div>

        <div className="ds_pic" id="ds2"></div>
      </section>
      <section className="ds">
        <div className="ds_txt naranjaDSB" id="que1">
          <h1 className="titulos-ds">¿QUÉ ES?</h1>
          <br />
          <p className="txt-cuerpo">
            Design Season incluye 4 cursos distribuidos en entregas diarias para
            que vayamos todes al mismo ritmo. Además{" "}
            <strong>Masterclass</strong> sobre temas complementarios,{" "}
            <strong>Blips</strong> con tips concretos y <strong>stories</strong>{" "}
            con más datita exclusiva. Y lo más importante,{" "}
            <strong>retos semanales</strong> para practicar y terminar el
            programa con un proyecto propio mostrable. En Discord hay un{" "}
            <strong>canal de soporte</strong> donde interactuamos a diario.
          </p>
          <br />
          <button
            className="btn-descarga"
            onClick={() => {
              descarguita();
            }}
          >
            Ver programa completo
          </button>
          <img src={letra3} alt="" className="letra-decorateLeft" />
        </div>
        <div className="ds_pic" id="que2"></div>
      </section>
      <section className="ds">
        <div className="ds_pic" id="c2">
          <img src={DS08} alt="" />
        </div>
        <div className="ds_txt celesteDSB" id="c1">
          <h1 className="titulos-ds">¿CUÁNDO?</h1>
          <br />
          <p className="txt-cuerpo">
            El programa intensivo dura 9 semanas, del 13 de febrero al 14 de
            abril de 2023. Al finalizar vas a seguir teniendo todos los videos
            en tu cuenta hasta el 30 de abril de 2023 por si querés repasar. La
            entrega de emails y contenido durante las 9 semanas es de lunes a
            viernes y calculamos que puede demandart entre 2 y 3 horas de
            atención y trabajo por día.
          </p>
          <br />
          <button
            className="btn-descarga"
            onClick={() => {
              descarguita();
            }}
          >
            Ver programa completo
          </button>
          <img src={letra6} alt="" className="letra-decorate" />
        </div>
      </section>
      <section className="ds">
        <div className="ds_txt naranjaDSB" id="quien1">
          <h1 className="titulos-ds">¿CON QUIÉN?</h1>
          <br />
          <p className="txt-cuerpo">
            Este programa fue creado y dirigido por{" "}
            <strong>Jonatan Ariste</strong> y{" "}
            <strong>Ceci Escamilla Gigirey</strong>. Quizás los conozcas más
            como <strong>CodeaRock</strong> (Jony) y{" "}
            <strong>Talleres a Color</strong> (Ceci), el nombre de sus escuelas
            digitales en donde te enseñan hace años a través de sus cursos
            online. Son un mix de perfiles que te va a asegurar una doble mirada
            y un abordaje amplio en el mundo del diseño de interfaces.
          </p>
          <br />
          <button
            className="btn-descarga"
            onClick={() => {
              descarguita();
            }}
          >
            Ver programa completo
          </button>
          <img src={letra5} alt="" className="letra-decorateLeft" />
        </div>
        <div className="ds_pic" id="quien2">
          <img src={CR} alt="" className="loguines" />
          <img src={TAC} alt="" className="loguines" />
        </div>
      </section>
      <section className="ds">
        <div className="ds_pic" id="c3">
          <img src={DS10} alt="" />
        </div>
        <div className="ds_txt celesteDSB" id="c4">
          <h1 className="titulos-ds">¿POR QUÉ?</h1>
          <br />
          <p className="txt-cuerpo">
            El perfil UX/UI es cada vez más requerido por lo tanto es una forma
            perfecta de insertarse en el creciente mercado de la tecnología. En
            Design Season vamos a prepararte para que empieces a trabajar en
            UX/UI teniendo las bases y fundamentos para tomar decisiones de
            diseño. ¡Y la práctica no puede faltar! Realmente hace la
            diferencia.
          </p>
          <br />
          <button
            className="btn-descarga"
            onClick={() => {
              descarguita();
            }}
          >
            Ver programa completo
          </button>
          <img src={letra4} alt="" className="letra-decorate" />
        </div>
      </section>
      <section className="cierre">
        <div className="cierreds">
          <h1 className="titulos-ds">
            ¿Cómo funcionan los precios del Design Season?
          </h1>
          <br />
          <p className="txt-cuerpo">
            El valor del ticket completo es $30.000, pero te vamos a descontar
            $3.000 por cada uno de estos cursos que tengas desde antes: UX de
            Codea Rock, Fundamentos del DG y/o Figma de Talleres a Color. <br />
            <span>
              *no hay descuento por el curso UI porque es completamente nuevo
            </span>
          </p>
          <div className="infoComprA">
            <button
              className="btn-azul finalbtn"
              onClick={() => {
                handleComprar();
              }}
            >
              comprar ticket
            </button>
            {precioFinal == 22000 ? (
              <p className="ds-precio">de $21.000 a $30.000</p>
            ) : (
              <>
                <del className="ds-del">de $21.000 a $30.000</del>
                <p className="ds-precio-viejos">{cursosQueTienen}</p>
                <p className="ds-precio">{precioLeyenda}</p>
              </>
            )}
            <p className="ds-cuotas">3 y 6 cuotas sin interés</p>
            <br /> <br />
          </div>
        </div>
        <img src={letra7} alt="" className="cierreLetra" />
      </section>
    </>
  );
}

export default DesignSeason;
